import { render, staticRenderFns } from "./loyalty-success-modal.vue?vue&type=template&id=08b3cbd3&scoped=true"
import script from "./loyalty-success-modal.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-success-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./loyalty-success-modal.scss?vue&type=style&index=0&id=08b3cbd3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3cbd3",
  null
  
)

export default component.exports